import { render, staticRenderFns } from "./EditItemWiseLedger.vue?vue&type=template&id=12e81f34&scoped=true"
import script from "./EditItemWiseLedger.vue?vue&type=script&lang=ts"
export * from "./EditItemWiseLedger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e81f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e81f34')) {
      api.createRecord('12e81f34', component.options)
    } else {
      api.reload('12e81f34', component.options)
    }
    module.hot.accept("./EditItemWiseLedger.vue?vue&type=template&id=12e81f34&scoped=true", function () {
      api.rerender('12e81f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/components/EditItemWiseLedger.vue"
export default component.exports